import { render, staticRenderFns } from "./RichTextToolbar.vue?vue&type=template&id=3c1ee35a&scoped=true"
import script from "./RichTextToolbar.vue?vue&type=script&lang=js"
export * from "./RichTextToolbar.vue?vue&type=script&lang=js"
import style0 from "./RichTextToolbar.vue?vue&type=style&index=0&id=3c1ee35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1ee35a",
  null
  
)

export default component.exports